import { useNavigate } from "react-router-dom";
import { saas } from "@/lib/saasApi";
import { useAuth } from "@/saas/AuthContext";

const AGENCY = ["AGENCY_ADMIN", "AGENCY_USER"];

// Shared routing for the public marketing CTAs (Stripe-ready, no payments yet).
export function useCtaActions() {
  const { user } = useAuth();
  const nav = useNavigate();

  const goLogin = () => nav("/login");
  const goDashboard = () => nav(user?.role === "OWNER_ADMIN" ? "/admin" : "/dashboard");

  // Primary "Start with Real Estate Pro": logged-in users go to their existing
  // area (never a second registration); logged-out users register.
  const goRegister = (plan) => {
    if (user && AGENCY.includes(user.role)) return nav("/dashboard");
    if (user && user.role === "OWNER_ADMIN") return nav("/admin");
    return nav(plan ? `/register?plan=${plan}` : "/register");
  };

  // Package button: logged-in customers keep their existing account (never a 2nd one).
  const goPackage = (plan) => {
    if (user && AGENCY.includes(user.role)) nav(`/account/billing?plan=${plan}`);
    else if (user && user.role === "OWNER_ADMIN") nav("/admin");
    else nav(`/register?plan=${plan}&next=checkout`);
  };

  // "Start with your first listing": smart, credit-aware routing.
  const goFirstListing = async () => {
    if (!user) return nav("/register?next=/projects/new");
    if (user.role === "OWNER_ADMIN") return nav("/admin");
    try {
      const { data } = await saas.summary();
      nav(data.availableCredits >= 1 ? "/projects/new" : "/account/billing");
    } catch {
      nav("/dashboard");
    }
  };

  return { goLogin, goDashboard, goRegister, goPackage, goFirstListing };
}
